export default __webpack_public_path__ + "static/media/logo-white.fb919265.png";